/*
Genérico para editar un input numerico formatead, y mantener
su equivalente "number".
Recibe una lista de los campos a formater. Los que no están en la lista
los procesa normal
*/

export interface FormatProps {
  name: string
  name_format: string
  isDecimal?: boolean
  isInteger?: boolean
}
export const handleInputChangeFormat = <T extends object>(
  e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>,
  formData: T | null,
  setFormData: React.Dispatch<React.SetStateAction<T | null>>,
  formatProps: FormatProps[] = []
) => {
  const { name, value, type } = e.target

  if (formData) {
    setFormData((prevFormData: T | null): T | null => {
      if (!prevFormData) return formData
      let updatedValue: string | number | Date = value

      if (type === 'number') {
        updatedValue = Number(value)
      }

      const formatProp = formatProps.find((prop) => prop.name_format === name)

      if (!formatProp) {
        return {
          ...prevFormData,
          [name]: updatedValue,
        }
      }

      let numericValue
      let num
      let num_format

      if (formatProp.isDecimal ?? false) {
        // Aceptamos decimales
        const locale: string = navigator.language
        const decimalChar = new Intl.NumberFormat(locale).format(1.1).charAt(1)

        // Create a regex to allow only digits and the locale-specific decimal character
        const regex = new RegExp(`[^\\d${decimalChar}]`, 'g')
        numericValue = value.replace(regex, '')
        const value_format = truncateToTwoDecimals(numericValue, decimalChar)
        numericValue = value_format.replace(decimalChar, '.')

        if (!numericValue) {
          numericValue = '0'
        }
        num = Number(numericValue)
        num_format = value_format
      } else if (formatProp.isInteger ?? false) {
        // Handle non-decimal input
        numericValue = value.replace(/[^\d]/g, '') // Strip non-numeric characters

        if (!numericValue) {
          numericValue = '0'
        }
        num = Number(numericValue)
        num_format = num !== 0 ? num.toString() : ''
      } else {
        // Handle non-decimal input
        numericValue = value.replace(/[^\d]/g, '') // Strip non-numeric characters

        if (!numericValue) {
          numericValue = '0'
        }
        num = Number(numericValue)
        num_format = num !== 0 ? new Intl.NumberFormat().format(num) : ''
      }

      return {
        ...prevFormData,
        [name]: num_format,
        [formatProp.name]: num,
      }
    })
  }
}
export const truncateToTwoDecimals = (valueStr: string, separator: string): string => {
  // Find the position of the decimal point
  const decimalIndex = valueStr.indexOf(separator)

  // If there's no decimal point, return the original string
  if (decimalIndex === -1) {
    return valueStr
  }

  // Extract the substring up to two decimal places
  const truncated = valueStr.substring(0, decimalIndex + 3) // +3 to include the decimal point and two digits

  return truncated
}
